import { ImageFragment } from "./article-card";

export enum PostType {
  KnowledgeCenter = "knowledge_center",
  Legal = "legal",
  PressRelease = "press_release",
  PressReport = "press_report",
}

export enum SocialPlatform {
  Facebook = "facebook",
  Instagram = "instagram",
  Linkedin = "linkedin",
  Reddit = "reddit",
  Tiktok = "tiktok",
  Twitter = "twitter",
  Website = "website",
  Youtube = "youtube",
}
export interface GenericAuthor {
  slug?: string;
  photoPlaceholder?: ImageFragment;
  person: {
    name: string;
  };
  biography: string;
  location: string;
  socialLinks: Array<{
    __typename?: "SocialLink";
    platform: SocialPlatform;
    url: string;
  }>;
  posts: Array<{
    __typename?: "Post";
    title: string;
    slug: string;
    createdAt: any;
    updatedAt: any;
    published: any;
    excerpt?: string | null;
    readingTime: number;
    postType: PostType;
    author?: {
      __typename?: "Author";
      slug: string;
      person?: {
        __typename?: "Person";
        name: string;
        photo?: {
          __typename?: "Asset";
          id: string;
          url: string;
          width?: number | null;
          height?: number | null;
          handle: string;
        } | null;
      } | null;
    } | null;
    coverImage?: {
      __typename?: "Asset";
      id: string;
      url: string;
      width?: number | null;
      height?: number | null;
      handle: string;
    } | null;
    aggregatePostPage?: {
      __typename?: "AggregatePostPage";
      title?: string | null;
      slug: string;
    } | null;
  }>;
}
